var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allcontens"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"account_content"},[_c('img',{staticClass:"account_img",attrs:{"src":require("@assets/agreement/correct.svg"),"alt":"完成代扣"}}),_c('span',{staticClass:"account_span"},[_vm._v("您的信息已认证")]),_c('span',{staticClass:"tips"})])])])
}]

export { render, staticRenderFns }